<template>
  <NuxtLink
    class="flex w-full items-center rounded-lg px-2 py-2 text-left text-[13px] font-medium text-zinc-600 transition-all hover:bg-zinc-950/5 hover:text-zinc-950"
    active-class="bg-zinc-950/5 text-zinc-950"
  >
    <span class="truncate">
      <slot />
    </span>
  </NuxtLink>
</template>
